// extracted by mini-css-extract-plugin
export default {"wrap":"eddb72b7f589","mainMessage":"ecd3e1d895c1","collapsed":"b5e72b1ae3d0"};